<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc1"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">Chapter 1. The First Long Islanders</a></p>
<p class="toc"><a href="#/chapter02">Chapter 2. Colonial Long Island</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Chapter 3. The Revolutionary Schism and the Occupation of Long Island</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Chapter 4. Expanding the Domestic Sphere in the Nineteenth Century</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Chapter 5. Long Island’s First Ladies</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Chapter 6. Novelists, Poets and Other Writers</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Chapter 7. Women and the Arts</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Chapter 8. Philanthropists and Humanitarians</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Chapter 9. Earning a Living: Entrepreneurs, Entertainers and Scientists</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Chapter 10. Pioneering Pilots: Daring and Intrepid Airwomen</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Chapter 11. Achieving Votes for Women</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Chapter 12. Civic and Political Activists</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Chapter 13. Years of Change, 1930–1980</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Chapter 14. Historians and Preservationists</span></p>
<p class="toc1"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/abbreviations" title="Link target outside of Sample">Abbreviations</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?28df3849